export const EmptyCards = ({ length }: { length: number }) => {
  return (
    <>
      {Array.from({ length: 8 - length }).map((_, index) => (
        <div key={index} />
      ))}
    </>
  )
}
